import { Link } from 'react-router-dom';
import { FOUNDERS } from '@/content/social-proof';
import { track } from '@/lib/analytics';
import { BOOK_CALL_URL } from '@/lib/site';
import { useLang, useLangHref, useT } from '@/lib/useLang';

/**
 * Le second bouton d'une agence : parler à quelqu'un avant de payer. Le
 * visage est celui de Stephen, qui prend les appels.
 *
 * Rien n'est rendu tant que `BOOK_CALL_URL` est vide — voir `lib/site.ts`.
 */
export function CallButton({ placement, tone = 'light' }: {
  placement: 'header' | 'hero' | 'white-label';
  tone?: 'light' | 'dark';
}) {
  const t = useT();
  const lang = useLang();
  const withLang = useLangHref();
  if (!BOOK_CALL_URL) return null;

  const host = FOUNDERS[0];

  return (
    <Link
      className={`nz-call nz-call--${tone}`}
      to={withLang(BOOK_CALL_URL)}
      onClick={() => track('call_cta_clicked', { placement, lang })}
    >
      <picture>
        <source srcSet={host.photo.webp} type="image/webp" />
        <img className="nz-call__face" src={host.photo.fallback} alt="" width={28} height={28} />
      </picture>
      {t.callCta}
    </Link>
  );
}
